import { ParsedUrlQuery } from 'querystring';
import { InvoiceStatusFilter } from './Invoices.types';
import { QUERY } from '@/constants/common';

export function getActiveStatusFilter(
  query: ParsedUrlQuery
): InvoiceStatusFilter {
  const status = query[QUERY.status];
  const values = Object.values(InvoiceStatusFilter) as string[];

  if (typeof status === 'string' && values.includes(status)) {
    return status as InvoiceStatusFilter;
  }

  return InvoiceStatusFilter.All;
}
